import store from '@/store';
import PcaService from '@/services/PcaDataProcess/PcaService'

const DataWatcherService = {
  unwatchers: [],
  
  init() {
    if (!store.state.kit.deepAncestryCoordinate) {
      return;
    }

    this.watchRegionState();
    this.watchConvexHullState();
  },

  watchRegionState() {
    const unwatch = store.watch(
      (state) => state.pcaRegion.selectedRegion,
      (newValue, oldValue) => {
        if (newValue !== oldValue) {
          this.runPcaPlotResult();
        }
      }
    );

    this.unwatchers.push(unwatch);
  },

  watchConvexHullState() {
    const unwatch = store.watch(
      (state) => state.pcaSourceData.isEnableConvexHull,
      (newValue, oldValue) => {
        if (newValue !== oldValue) {
          this.runPcaPlotResult();
        }
      }
    );

    this.unwatchers.push(unwatch);
  },

  async runPcaPlotResult() {
    try {
      const sourceDataRequest = {
        regionId: store.state.pcaRegion.selectedRegion.id,
      };
      const sourceDataResult = await store.dispatch('pcaSourceData/fetchPcaSourceData', sourceDataRequest);
      if (!sourceDataResult) {
        return;
      }

      const kitName = store.state.kit.kitName.replaceAll(' ', '_');
      let coordinate = store.state.kit.deepAncestryCoordinate;
      if (coordinate) {
        const splitCoordinate = coordinate.split(',');
        if(splitCoordinate.length > 0) {
          coordinate = coordinate.replace(splitCoordinate[0], kitName)
        }
      }

      PcaService.sourceObject.isEnableConvexHull = store.state.pcaSourceData.isEnableConvexHull;
      PcaService.sourceObject.selectedTargetTitle = kitName;
      PcaService.onSetSourceDatas(sourceDataResult.sourceData, coordinate);
      PcaService.runPCA();
      PcaService.plotPCA();
    } catch (error) {
      console.error('Error handling specific state change:', error);
    }
  },

  cleanup() {
    this.unwatchers.forEach(unwatch => unwatch());
    this.unwatchers = [];
  },
};

export default DataWatcherService;
